import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import flyingEduman from '../assets/images/eduman+eduwoman.svg';
import ViewAll from "../components/buttons/ViewAll";
import CarouselComp from "../components/carousel/CarouselComp";
import SliderComp from "../components/carousel/SliderComp";
import StatusBar from "../components/statusBar/StatusBar";
import HoverButton from "../components/buttons/HoverButton";
import RedirectIcon from "../components/icons/utility/RedirectIcon"
import { useAuth } from "../contexts/session";
import '../assets/css/pages/home.css'
// import esc6Logo from "../assets/images/icons/esc6-logo.png";

const Home = () => {
    const { userObj, isLoading } = useAuth();        
    const [viewMore, setViewMore] = useState(false);
    const [catelogSelection, setCatelogSelection] = useState("my plans");
    const [courses, setCourses] = useState([
        {
            id: 1,
            src: require("../assets/images/icons/esc6-logo.png"),
            status: 82,
            title: "example course 1",
        },
        {
            id: 2,
            src: require("../assets/images/icons/esc6-logo.png"),
            status: 94,
            title: "example course long name 2",
        },
        {
            id: 3,
            src: require("../assets/images/icons/esc6-logo.png"),
            status: 62,
            title: "course 3",
        },
        {
            id: 4,
            src: require("../assets/images/icons/esc6-logo.png"),
            status: 24,
            title: "another course with an abnormally long name 4",
        },
        {
            id: 5,
            src: require("../assets/images/icons/esc6-logo.png"),
            status: 45,
            title: "example course super duper extra longer than long name 5",
        },
    ]);
    const [completions, setCompletions] = useState([
        {
            id: 1,
            src: require("../assets/images/icons/esc6-logo.png"),
            grade: Math.round(Math.random()*100),
            title: "example completion 1",
            completion_date: new Date().toLocaleDateString(),
            passing_grade: 70
        },
        {
            id: 2,
            src: require("../assets/images/icons/esc6-logo.png"),
            grade: Math.round(Math.random()*100),
            title: "example completion long name 2",
            completion_date: new Date().toLocaleDateString(),
            passing_grade: 70
        },
        {
            id: 3,
            src: require("../assets/images/icons/esc6-logo.png"),
            grade: Math.round(Math.random()*100),
            title: "completion 3",
            completion_date: new Date().toLocaleDateString(),
            passing_grade: 70
        },
        {
            id: 4,
            src: require("../assets/images/icons/esc6-logo.png"),
            grade: Math.round(Math.random()*100),
            title: "another completion with an abnormally long name 4",
            completion_date: new Date().toLocaleDateString(),
            passing_grade: 70
        },
        {
            id: 5,
            src: require("../assets/images/icons/esc6-logo.png"),
            grade: Math.round(Math.random()*100),
            title: "example completion super duper extra longer than long name 5",
            completion_date: new Date().toLocaleDateString(),
            passing_grade: 70
        },
    ]);
    const [plans, setPlans] = useState([
        {
            id: 1,
            title: "example plan 1",
            status: Math.round(Math.random()*100),
            expiration: "1 Day"
        },
        {
            id: 2,
            title: "example plan long name 2",
            status: Math.round(Math.random()*100),
            expiration: "25 Days"
        },
        {
            id: 3,
            title: "Plan 3",
            status: Math.round(Math.random()*100),
            expiration: "3 Months"
        },
        {
            id: 4,
            title: "another plan with an abnormally long name 4",
            status: Math.round(Math.random()*100),
            expiration: "1 Year"
        },
        {
            id: 5,
            title: "example plan super duper extra longer than long name 5",
            status: Math.round(Math.random()*100),
            expiration: "4 Years"
        },
        // {
        //     title: "Plan 6",
        //     status: Math.round(Math.random()*100),
        //     expiration: "Unlimited"
        // },
        // {
        //     title: "Plan 7",
        //     status: Math.round(Math.random()*100),
        //     expiration: "13 Hours"
        // },
    ]);
    // const [popularCourses, setPopularCourses] = useState([
    //     {
    //         id: 1,
    //         src: require("../assets/images/icons/esc6-logo.png"),
    //         title: "title #1-1"
    //     },
    //     {
    //         id: 2,
    //         src: require("../assets/images/icons/esc6-logo.png"),
    //         title: "title #1-2"
    //     },
    //     {
    //         id: 3,
    //         src: require("../assets/images/icons/esc6-logo.png"),
    //         title: "title #1-3"
    //     },
    //     {
    //         id: 4,
    //         src: require("../assets/images/icons/esc6-logo.png"),
    //         title: "title #1-4"
    //     },
    //     {
    //         id: 5,
    //         src: require("../assets/images/icons/esc6-logo.png"),
    //         title: "title #1-5"
    //     },
    //     {
    //         id: 6,
    //         src: require("../assets/images/icons/esc6-logo.png"),
    //         title: "title #1-6"
    //     },
    //     {
    //         id: 7,
    //         src: require("../assets/images/icons/esc6-logo.png"),
    //         title: "title #1-7"
    //     },
    //     {
    //         id: 8,
    //         src: require("../assets/images/icons/esc6-logo.png"),
    //         title: "title #1-8"
    //     },
    // ]);
    // const [newestCourses, setNewestCourses] = useState([
    //     {
    //         id: 1,
    //         src: require("../assets/images/icons/esc6-logo.png"),
    //         title: "title #2-1"
    //     },
    //     {
    //         id: 2,
    //         src: require("../assets/images/icons/esc6-logo.png"),
    //         title: "title #2-2"
    //     },
    //     {
    //         id: 3,
    //         src: require("../assets/images/icons/esc6-logo.png"),
    //         title: "title #2-3"
    //     },
    //     {
    //         id: 4,
    //         src: require("../assets/images/icons/esc6-logo.png"),
    //         title: "title #2-4"
    //     },
    //     {
    //         id: 5,
    //         src: require("../assets/images/icons/esc6-logo.png"),
    //         title: "title #2-5"
    //     },
    //     {
    //         id: 6,
    //         src: require("../assets/images/icons/esc6-logo.png"),
    //         title: "title #2-6"
    //     },
    //     {
    //         id: 7,
    //         src: require("../assets/images/icons/esc6-logo.png"),
    //         title: "title #2-7"
    //     },
    //     {
    //         id: 8,
    //         src: require("../assets/images/icons/esc6-logo.png"),
    //         title: "title #2-8"
    //     },
    // ]);
    // const [coursesYouMayLike, setCoursesYouMayLike] = useState([
    //     {
    //         id: 1,
    //         src: require("../assets/images/icons/esc6-logo.png"),
    //         title: "title #3-1"
    //     },
    //     {
    //         id: 2,
    //         src: require("../assets/images/icons/esc6-logo.png"),
    //         title: "title #3-2"
    //     },
    //     {
    //         id: 3,
    //         src: require("../assets/images/icons/esc6-logo.png"),
    //         title: "title #3-3"
    //     },
    //     {
    //         id: 4,
    //         src: require("../assets/images/icons/esc6-logo.png"),
    //         title: "title #3-4"
    //     },
    //     {
    //         id: 5,
    //         src: require("../assets/images/icons/esc6-logo.png"),
    //         title: "title #3-5"
    //     },
    //     {
    //         id: 6,
    //         src: require("../assets/images/icons/esc6-logo.png"),
    //         title: "title #3-6"
    //     },
    //     {
    //         id: 7,
    //         src: require("../assets/images/icons/esc6-logo.png"),
    //         title: "title #3-7"
    //     },
    //     {
    //         id: 8,
    //         src: require("../assets/images/icons/esc6-logo.png"),
    //         title: "title #3-8"
    //     },
    // ]);
    const [latest, setLatest] = useState([
        {
            id: 1,
            src: require("../assets/images/cyber-banner.jpg"),
            title: "title #1-1",
            desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maiores, distinctio esse? Blanditiis obcaecati laboriosam sunt?"
        },
        // {
        //     id: 2,
        //     src: require("../assets/images/icons/esc6-logo.png"),
        //     title: "title #1-2",
        //     desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maiores, distinctio esse? Blanditiis obcaecati laboriosam sunt?"
        // },
        // {
        //     id: 3,
        //     src: require("../assets/images/icons/esc6-logo.png"),
        //     title: "title #1-3",
        //     desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maiores, distinctio esse? Blanditiis obcaecati laboriosam sunt?"
        // },
        // {
        //     id: 4,
        //     src: require("../assets/images/icons/esc6-logo.png"),
        //     title: "title #1-4",
        //     desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maiores, distinctio esse? Blanditiis obcaecati laboriosam sunt?"
        // },
        // {
        //     id: 5,
        //     src: require("../assets/images/icons/esc6-logo.png"),
        //     title: "title #1-5",
        //     desc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Maiores, distinctio esse? Blanditiis obcaecati laboriosam sunt?"
        // },
    ]);

    useEffect(() => {
        let els = document.querySelectorAll(".home h2");
        
        
        function animate(el, t = 0) {
            const xRadianUpperBound = (Math.random()*(.6 - .4)) + .4;
            const xRadianLowerBound = (Math.random() * (.4 - .1)) + .1;
            const xRadiusUpperBound = (Math.random() * (13 - 10)) + 10;
            const xRadiusLowerBound = (Math.random() * (7 - 4)) + 4;
            const yRadianUpperBound = (Math.random() * (.6 - .4)) + .4;
            const yRadianLowerBound = (Math.random() * (.4 - .1)) + .1;
            const yRadiusUpperBound = (Math.random() * (7 - 4)) + 4;
            const yRadiusLowerBound = (Math.random() * (4 - 1)) + 1;
            const rate = (Math.random() * (.0185 - .0125)) + .0125;

            let modifier = Math.round(Math.random());            
            if(!modifier){
                modifier = -1;
            }
            else{
                modifier = 1
            }

            function frame(){
                // console.log(rate);
                

                // Use sine and cosine for smooth circular/elliptical motion
                // const x = Math.sin(t * 0.6) * 13 + Math.sin(t * 0.9) * 8;
                // const y = Math.cos(t * 0.3) * 5 + Math.sin(t * 0.7) * 3;
                const x = (modifier * Math.sin(t * xRadianLowerBound) * xRadiusUpperBound + Math.sin(t * xRadianUpperBound) * xRadiusLowerBound);
                const y = (modifier * Math.cos(t * yRadianLowerBound) * yRadiusUpperBound + Math.sin(t * yRadianUpperBound) * yRadiusLowerBound);
                const rotation = (modifier * Math.sin(t * yRadianLowerBound) * (xRadiusLowerBound * .7)); // small sway
                

                el.style.transform = `translate(calc(0% + ${x}px), calc(0% + ${y}px)) rotate(${rotation}deg)`;
                
                t += rate;
                requestAnimationFrame(frame);
            }
            frame();
        }
    
        els.forEach((el, i) => {
            if(!el.style){
                return;
            }

            animate(el);
        })
    }, []);

    
    // const printCategorySelector = () => {
    //     switch (catelogSelection) {
    //         case "my plans":
    //             return popularCourses.map(course => (
    //                 <div className="flex flexColumn flexCenter home-category-slider-slide-container" key={"catelog_"+course.id}>
    //                     <img src={course.src} alt="popular course" className="home-category-slider-slide-img" />
    //                     <div className="textAlignCenter home-category-slider-slide-title">{course.title}</div>
    //                 </div>
    //             ));
    //         case "completions":
    //             return newestCourses.map(course => (
    //                 <div className="flex flexColumn flexCenter home-category-slider-slide-container" key={"catelog_"+course.id}>
    //                     <img src={course.src} alt="popular course" className="home-category-slider-slide-img" />
    //                     <div className="textAlignCenter home-category-slider-slide-title">{course.title}</div>
    //                 </div>
    //             ));
    //         case "quick access":
    //             return coursesYouMayLike.map(course => (
    //                 <div className="flex flexColumn flexCenter home-category-slider-slide-container" key={"catelog_"+course.id}>
    //                     <img src={course.src} alt="popular course" className="home-category-slider-slide-img" />
    //                     <div className="textAlignCenter home-category-slider-slide-title">{course.title}</div>
    //                 </div>
    //             ));
    //         default:
    //             return [];
    //     }
    // }

    return(
        <>
            <div className="flex flexColumn flexAlignCenter home">
                {/* <section className="featuredContent flex flexColumn flexAlignCenter">
                    <div className="featuredContentTextContainer flex flexAlignBottom">
                        <CarouselComp></CarouselComp> 
                    </div>
                    <div className="featuredContentSlideContainer flex flexJustifySpaceBetween">
                        <div className="featuredContentSlideLeftArrow"></div>
                        <div className="featuredContentSlideRightArrow"></div>
                    </div>
                </section> */}

                <section className="home-latestSection flex flexColumn flexCenter">
                    {/* <div className="home-lading-welcome flex flexAlignCenter flexJustifyStart">
                        Welcome, {(!isLoading && userObj) ? userObj.first_name + " " + userObj.last_name : "--- ---"}
                    </div> */}

                    {/* <div className="home-latest-titleContainer flex flexCenter">
                        <div className="home-latest-titleWrapper flex flexAlignCenter flexJustifyStart">
                            <h2 className="flex flexCenter">latest</h2>
                        </div>
                        <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Asperiores, sit labore. Quo placeat dicta officiis quidem suscipit laudantium, optio reiciendis dolorem!</p>
                    </div> */}

                    <div className="home-latest-container">
                        <Link to={"../coursePlayer/" + latest[0].id} className="home-latest-slideLarge flex flexCenter">
                        {/* <Link to={"../catelog/courses/" + latest[0].id} className="home-latest-slideLarge flex flexCenter"> */}
                            <img src={latest[0].src} alt="large slide" key={"slide_"+latest[0].id} />
                            <div className="home-latest-slide-info">
                                <h3>{latest[0].title}</h3>
                                <p>{latest[0].desc}</p>
                            </div>
                        </Link>
                        <div className="home-latest-slideContainer">
                            {latest.map((course, i) => {
                                if(i > 0){
                                    return (
                                        <Link to={"../catelog/courses/" + course.id} className="home-latest-slideSmall">
                                            <img src={course.src} alt="small slides" key={"slide_"+course.id} />
                                            <div className="home-latest-slide-info">
                                                <h3>{course.title}</h3>
                                                <p>{course.desc}</p>
                                            </div>
                                        </Link>
                                    )
                                }
                            })}
                        </div>
                    </div>
                    <div className="home-latest-bottomCityBoxShadow" />
                </section>


                <section className="home-heroHub">
                    
                    <h2 className="home-heroHub-title">
                        hero hub
                    </h2>
                    <div className="home-heroHub-container flex flexColumn flexCenter">
                        <div className="home-heroHub-categoryContainer flex flexCenter">
                            <div className="home-heroHub-categoryWrapper flex flexAlignCenter flexJustifyStart">
                                <div className={"home-heroHub-category textAlignCenter " + ((catelogSelection === "my plans" ? "home-heroHub-categorySelected" : "" ))} onClick={() => setCatelogSelection("my plans")}>my plans</div>
                                <div className={"home-heroHub-category textAlignCenter " + ((catelogSelection === "completions" ? "home-heroHub-categorySelected" : "" ))} onClick={() => setCatelogSelection("completions")}>completions</div>
                                <div className={"home-heroHub-category textAlignCenter " + ((catelogSelection === "quick access" ? "home-heroHub-categorySelected" : "" ))} onClick={() => setCatelogSelection("quick access")}>quick access</div>
                            </div>
                            <div className="home-heroHub-categoryImg">
                                <img className="home-heroHub-img" src={flyingEduman} alt="eduman and eduwoman" />
                            </div>
                        </div>
                        <div className={"home-heroHub-table home-expiringPlans-section " + (viewMore ? "homeViewMore" : "")}>
                            <div className="home-expiringPlans-tableWrapper flex flexColumn flexCenter">
                                <div className="home-heroHub-category-titleContainer flex flexAlignCenter flexJustifySpaceBetween">
                                    { catelogSelection === "my plans" && 
                                        <div className="home-heroHub-category-title">
                                            plans                                    
                                        </div>
                                    }
                                    { catelogSelection === "completions" && 
                                        <div className="home-heroHub-category-title">
                                            completions
                                        </div>
                                    }
                                    { catelogSelection === "quick access" && 
                                        <div className="home-heroHub-category-title">
                                            courses
                                        </div>
                                    }
                                    <div className="home-heroHub-category-myLearningContainer flex flexAlignCenter flexJustifyEnd">
                                        <Link to={"../learning"} className="home-heroHub-category-myLearningLink flex flexCenter">
                                            go to my learning
                                            <RedirectIcon redirectClass={"home-heroHub-redirectIcon"}></RedirectIcon>
                                        </Link>
                                    </div>
                                </div>
                                <div className="home-heroHub-tableContainer">
                                    <table>
                                        <tbody>
                                            { catelogSelection === "my plans" && 
                                                plans.map(plan => {                                        
                                                    return (
                                                        <>
                                                            <tr className="textAlignCenter home-heroHub-myPlans">
                                                                <td className="textAlignLeft home-heroHub-myPlans-title">
                                                                    <Link to={"../learing/plans/"+plan.id}>{plan.title}</Link>
                                                                </td>
                                                                <td><StatusBar status={plan.status} suffix="%" /></td>
                                                                <td><HoverButton hoverClass="launch-button home-heroHub-pill">Launch</HoverButton></td>
                                                                <td>{plan.expiration}</td>
                                                            </tr>
                                                        </>
                                                    )
                                                })
                                            }
                                            { catelogSelection === "completions" && 
                                                completions.map(completion => {
                                                    return (
                                                        <>
                                                            <tr className="textAlignCenter home-heroHub-completions">
                                                                <td className="textAlignLeft">{completion.title}</td>
                                                                <td className={(completion.grade >= completion.passing_grade) ? "home-heroHub-passingGrade" : "home-heroHub-failingGrade"}>
                                                                    <div className="home-heroHub-grade home-heroHub-pill flex flexCenter">
                                                                        {completion.grade}/100
                                                                    </div>
                                                                </td>
                                                                <td>{completion.grade >= completion.passing_grade ? 
                                                                    <HoverButton hoverClass="launch-button home-heroHub-pill">Download Certificate</HoverButton> 
                                                                    : 
                                                                    <HoverButton hoverClass="restart-button home-heroHub-pill">restart</HoverButton>}</td>
                                                                <td>{completion.completion_date}</td>
                                                            </tr>
                                                        </>
                                                    );
                                                })
                                            }
                                            { catelogSelection === "quick access" && 
                                                courses.map(course => {
                                                    return (
                                                        <>
                                                            <tr className="textAlignCenter home-heroHub-quickAccess">
                                                                <td className="textAlignLeft home-heroHub-quickAccess-title">
                                                                    <Link to={"../catelog/"+course.id}>{course.title}</Link>
                                                                </td>
                                                                <td><StatusBar status={course.status} suffix="%" /></td>
                                                                <td><HoverButton hoverClass="launch-button home-heroHub-pill">Launch</HoverButton></td>
                                                                <td><HoverButton hoverClass="restart-button home-heroHub-pill">Restart</HoverButton></td>
                                                            </tr>
                                                        </>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                {/* <div className={"home-expiringPlans-viewMore textAlignCenter " + (viewMore ? "homeViewMore" : "")} onClick={() => {
                                    setViewMore(prev => prev ? false : true );
                                }}>
                                    {viewMore ? "View Less" : "View More"}
                                </div> */}
                            </div>
                        </div>
                    </div>
                </section>

                {/* <section className="tripleSlidePanel flex flexCenter">
                    <div>
                        <h2>POPULAR COURSES</h2>
                        <div className="tripleSlide">
                            <div className="tripleSlideArrowLeft"></div>
                            <div className="tripleSlideArrowRight"></div>
                        </div>
                        <div className="tripleSlideViewAllBar flex flexCenter">
                            <ViewAll>../learning/courseId</ViewAll>
                        </div>
                    </div>
                    <div>
                        <h2>YOU MIGHT LIKE</h2>
                        <div className="tripleSlide">
                            <div className="tripleSlideArrowLeft"></div>
                            <div className="tripleSlideArrowRight"></div>
                        </div>
                        <div className="tripleSlideViewAllBar flex flexCenter">
                            <ViewAll>../learning/courseId</ViewAll>
                        </div>
                    </div>
                    <div>
                        <h2>NEW COURSES</h2>
                        <div className="tripleSlide">
                            <div className="tripleSlideArrowLeft"></div>
                            <div className="tripleSlideArrowRight"></div>
                        </div>
                        <div className="tripleSlideViewAllBar flex flexCenter">
                            <ViewAll>../learning/courseId</ViewAll>
                        </div>
                    </div>
                </section> */}
                {/* <section className="quickResume-plansPanel flex">
                    <section className="quickResume">
                        <div>
                            <h2>QUICK RESUME</h2>
                            <div className="flex flexJustifyEnd">
                                <ViewAll>../learning/courseId</ViewAll>
                            </div>
                            <p className="textAlignCenter">Quickly resume the last 5 courses you've exited from.</p>
                        </div>
                        <table>
                            <tr></tr>
                            <tr></tr>
                            <tr></tr>
                            <tr></tr>
                            <tr></tr>
                        </table>
                    </section>
                    <section className="myPlans">
                        <div>
                            <h2>MY PLANS</h2>
                            <div className="flex flexJustifyEnd">
                                <ViewAll>../learning/courseId</ViewAll>
                            </div>
                            <p className="textAlignCenter">Quickly view your five oldest plans assigned to you.</p>
                        </div>
                        <table>
                            <tr></tr>
                            <tr></tr>
                            <tr></tr>
                            <tr></tr>
                            <tr></tr>
                        </table>
                    </section>
                </section>
                <section className="thisJustInPanel">
                    <img alt="Eduhero Mascot Flying" className="flyingEduman" src={flyingEduman}></img>
                    <div className="thisJustInContenContainer">
                        <div>
                            <h2>THIS JUST IN</h2>
                            <div className="flex flexJustifyEnd">
                                <ViewAll>../learning/courseId</ViewAll>
                            </div>
                            <p className="textAlignCenter">View the latest and greatest in Eduhero with these blogs and news!</p>
                        </div>
                        <table>
                            <tr></tr>
                            <tr></tr>
                            <tr></tr>
                            <tr></tr>
                            <tr></tr>
                        </table>
                    </div>
                    
                </section> */}
                
                {/* <section className="home-quickResume-section flex flexColumn flexCenter">
                    <SliderComp containerClass="home-quickResume-container" wrapperClass="home-quickResume-wrapper" buttonClass="home-quickResume-button">
                        {courses.map(course => {
                            return (
                                <div className="home-quickResume-course" key={"course_"+course.id}>
                                    <img src={course.src} alt="Course Img" />
                                    <div className="home-quickResume-course-status flex flexCenter">
                                        <StatusBar status={course.status} suffix="%" />
                                        <HoverButton hoverClass="launch-button">Launch</HoverButton>
                                    </div>
                                    <div className="home-quickResume-course-title textAlignCenter">
                                        {course.title}
                                    </div>
                                </div>
                            )
                        })}
                    </SliderComp>
                </section>

                

                <section className="home-category-section flex flexColumn flexCenter">
                    <div className="home-category-categoryContainer flex flexCenter">
                        <button type="button" className={"home-catelog-category " + ((catelogSelection === "popular courses") ? "home-catelog-categorySelected" : "")} onClick={() => setCatelogSelection("popular courses")}>popular courses</button>
                        <button type="button" className={"home-catelog-category " + ((catelogSelection === "newest courses") ? "home-catelog-categorySelected" : "")} onClick={() => setCatelogSelection("newest courses")}>newest courses</button>
                        <button type="button" className={"home-catelog-category " + ((catelogSelection === "courses you may like") ? "home-catelog-categorySelected" : "")} onClick={() => setCatelogSelection("courses you may like")}>courses you may like</button>
                        <button type="button" className="home-catelog-category flex flexCenter">view full catelog <RedirectIcon redirectClass="home-category-redirect" /></button>
                    </div>
                    <div className="home-category-sliderContainer flex flexColumn flexCenter">
                        <div className="home-category-desc">
                            {(catelogSelection === "popular courses") && "Here are some of Eduhero's most popular courses!"}
                            {(catelogSelection === "newest courses") && "Check out Eduhero's newest courses!"}
                            {(catelogSelection === "courses you may like") && "Scroll through suggested Eduhero's Courses that may interest you!"}
                        </div>
                        <SliderComp numOfSlides={3} containerClass="home-category-slider-container" wrapperClass="home-category-slider-wrapper" buttonClass="home-category-slider-button" bubbles={true} bubbleActiveClass="home-category-slider-bubblesActive" bubbleContainerClass="home-category-slider-bubblesContainer" bubbleClass="home-category-slider-bubbles">
                            {printCategorySelector()}
                        </SliderComp>
                    </div>
                </section> */}
            </div>
        </>
    );
};

export default Home;